import React from "react";
import { useFreightRatesLogic } from "./useFreightRatesLogic";
import FreightRatesDesktop from "./FreightRatesDesktop";
import FreightRatesMobile from "./FreightRatesMobile";
import useIsMobile from "../../hooks/useIsMobile";

const FreightRates = (props) => {
  const isMobile = useIsMobile();
  const logic = useFreightRatesLogic();

  return isMobile ? (
    <FreightRatesMobile {...logic} />
  ) : (
    <FreightRatesDesktop {...logic} />
  );
};

export default FreightRates;
